export var SchemaVersion;
(function(SchemaVersion) {
    SchemaVersion["V1"] = "1";
})(SchemaVersion || (SchemaVersion = {}));

//# sourceMappingURL=types.js.map